var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.233 198.233",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.164,185.409l-91.26-179.84c-1.277-2.518-3.861-4.104-6.685-4.106c-0.001,0-0.002,0-0.003,0 c-2.822,0-5.405,1.584-6.685,4.1L0.815,185.87c-1.382,2.718-0.982,6.002,1.013,8.308c1.995,2.307,5.188,3.175,8.076,2.197 l89.202-30.186l89.202,30.186c0.789,0.267,1.6,0.396,2.403,0.396c0.041,0,0.081,0,0.122-0.001c4.096-0.054,7.399-3.391,7.399-7.5 C198.233,187.858,197.843,186.537,197.164,185.409z M94.217,152.007L22.53,176.266L94.217,35.335V152.007z M104.217,152.081V35.389 l71.492,140.885L104.217,152.081z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrow);
export default __webpack_public_path__ + "static/media/nav_arrow.9b98ca6ae5378b33dcf56463cba95ec5.svg";
export { ForwardRef as ReactComponent };